import {SortOption, SortProperty} from '../interfaces';

export function getDefaultSortOptions(): SortOption[] {
    return [
        {
            property: SortProperty.Source,
            direction: 'asc',
            isActive: false
        },
        {
            property: SortProperty.Supplier,
            direction: 'asc',
            isActive: false
        },
        {
            property: SortProperty.Rating,
            direction: 'asc',
            isActive: false
        },
        {
            property: SortProperty.Quantity,
            direction: 'asc',
            isActive: false
        },
        {
            property: SortProperty.FirstPrice,
            direction: 'asc',
            isActive: true
        },
        {
            property: SortProperty.Price,
            direction: 'asc',
            isActive: false
        },
        {
            property: SortProperty.DeliveryDays,
            direction: 'asc',
            isActive: false
        },
        {
            property: SortProperty.DeliveryDate,
            direction: 'asc',
            isActive: false
        }
    ];
}
